export default __webpack_public_path__ + "static/media/6_long.663a443a.svg";